import { Avatar, Card, CardContent, Grid } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IAutomatedEmailCampaignListPayload, IJob } from 'wisestep-api';
import { WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

import useGetJobCampaignAnalytics from '../../../../features/emailSettings/hooks/useGetJobCampaignAnalytics';
import { IJobCampaignEmailTabTypes } from '../../../../features/emailSettings/util/JobCampaignEmailHelper';
import AI_Image from '../../../../images/AI.svg';
import { getDeliveryStats } from '../helper/JobsCrmHelper';

const JobEmailCampaignAnalytics = ({ job }: { job: IJob }) => {
  const navigate = useNavigate();
  const [search] = useState<IAutomatedEmailCampaignListPayload>({
    jobId: job.id ?? '',
  } as IAutomatedEmailCampaignListPayload);
  const { analytics } = useGetJobCampaignAnalytics(search);

  const campaignSummaryStats = getDeliveryStats(analytics?.resultSet);

  const navigateEmailCampaign = () =>
    navigate(
      `/jobs/job-email-campaign?jobId=${job.id}&type=${IJobCampaignEmailTabTypes.ANALYTICS}&campaignCode=${campaignSummaryStats.DELIVERED.campaignCode}`
    );
  return (
    <Card>
      <CardContent>
        <Grid container alignItems="center" columnGap={1}>
          <Grid item>
            <Avatar src={AI_Image} variant="square" />
          </Grid>
          <Grid item xs container justifyContent="space-between" alignItems="center">
            <Grid item display="flex" direction="column" rowGap={0.5}>
              <WsTypography variant={WsTypoVariants.TITLE} bold>
                Email Campaign Summary
              </WsTypography>
              <WsTypography variant={WsTypoVariants.BODY2}>
                {`Sent- ${campaignSummaryStats.SENT.value ?? 0} | Delivered- ${
                  campaignSummaryStats.DELIVERED.value
                } | Read- ${campaignSummaryStats.OPENED.value} | Not Delivered- ${
                  campaignSummaryStats.BOUNCED.value
                }`}
              </WsTypography>
            </Grid>
            <Grid item>
              <WsButton size="small" onClick={navigateEmailCampaign}>
                View Details
              </WsButton>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JobEmailCampaignAnalytics;
